const enGBTranslations = {
  onboarding1: {
    header: 'Welcome to SomeBuddy!',
    body1: 'Got a worry? Tell ',
    body2: 'SomeBuddy',
    body3: '.',
    continueButton: 'Start',
  },
  onboarding2: {
    header:
      'Ask for help and get a response from our emergency unit quickly and easily.',
    list: {
      first: {
        header: 'Crime or not',
        body: 'Our experts know where to draw the line. Not everything has to be tolerated.',
      },
      second: {
        header: 'Psychological first aid',
        body: 'Being bullied or harassed can have a negative impact on your well-being. We help you to take care of yourself.',
      },
      third: {
        header: 'Action plan',
        body: 'We will give you tailored recommendations to solve the situation. We can also give you good advice on social media.',
      },
    },
    continueButton: 'Continue',
  },
  terms: {
    header: 'SomeBuddy helps you stay safe.',
    body: `
      Before we start, we need to make sure you're okay with [the rules of our service](https://somebuddy.com/legal/uk-terms-of-service) and [how we look after your information](https://somebuddy.com/legal/uk-privacy-policy) to keep you safe.`,
    continueButton: 'Continue',
    termsAccepted: 'I agree to the rules 🤝',
    privacyPolicyAccepted: 'I am okay with how you use my info 🔒.',
  },
  cookieConsent: {
    title: 'Cookies help our app to run smoothly and securely.',
    description:
      'Choose which cookies you use. You can change your cookie settings at any time. [Read more](https://www.somebuddy.com/legal/cookie-policy/).',
    acceptAll: 'Accept all',
    essentialOnly: 'Only necessary',
    goToSettings: 'Edit cookie settings',
  },
  functionalCookieConsent: {
    title:
      'To start a chat you need to enable functional cookies.\nIs that OK with you? 🍪',
    explainer: 'What are functional cookies?',
    accept: 'Yes',
    decline: 'No',
  },
  cookieSettings: {
    title: 'Set your cookie preferencies',
    necessary: {
      title: '🍞 Essentials',
      description:
        'These cookies are necessary for the functioning of the site and cannot be disabled. We use essential cookies, for example, to remember the cookie settings you have chosen and to secure your access to the service.',
      value: 'Always on',
    },
    functional: {
      title: '🥞 Functional',
      description:
        'Functional cookies enable additional features, such as the customer service chat. If you do not accept these cookies, some features of our service may not work properly (for example, you may not be able to send us a message in the chat).',
    },
    statistics: {
      title: '🎂 Measurements and analytics',
      description:
        'These cookies collect anonymous statistical information for us. This information allows us to monitor the use and performance of our service. Measurement cookies allow us to provide high quality user experience and to quickly identify and fix any problems with our service.',
      nativeShellNote:
        "We don't use analytics cookies if you log in as a student.",
    },
    acceptSettings: 'Save and continue',
  },
  error: {
    back: 'Continue',
    defaultError: 'Ups! Something unexpected happened.',
    404: 'Dang! This page does not exists.',
    401: 'Sorry! You do not have access to this information.',
  },
  phone: {
    header: 'Log in!',
    footer1:
      'You will receive a one-time password by text message to log into the service.',
    emailLogin: 'Do you want to log in by email?',
    subheader: '',
    footer2: '',
    error: {
      isRequired: 'You must enter a valid phone number',
      cannotSend: 'The text message could not be sent',
      invalidFormat: 'The phone number you entered is not valid',
    },
  },
  captcha: {
    challengeError:
      'Something went wrong. Please wait a moment and then refresh the page to try again. \nIf the problem continues, please contact us through the chat.',
    verificationError:
      'Something went wrong. Please refresh the page to try again.',
    notSolvedError: 'Please complete the security test to continue.',
  },
  email: {
    header: 'Log in!',
    description1:
      'You will receive a one-time password by email to log into the service.',
    description2: '',
    placeholder: 'Email',
    phoneLogin: 'Sign up by phone number',
    subheader: '',
    footer2: '',
    error: {
      isRequired: 'You must enter a valid email address',
      cannotSend: 'The email could not be sent',
      badDomain: 'Domain name is not allowed',
      invalidFormat: 'E-postadressen du angav är inte giltig',
    },
  },
  pin: {
    header: 'Enter the one-time password',
    descriptionPhone:
      'You will receive a text message within a couple of minutes containing a six-digit password to {phoneNumber}.',
    descriptionEmail:
      'You will receive an email within a couple of minutes containing a six-digit password to {email}.',
    resendCodePhone:
      "Didn't get a one-time password? Click [here](/) to get a new code.",
    resendCodeEmail:
      "Didn't get a one-time password? Click [here](/email) to get a new code.",
    keepSignedIn:
      'Keep me signed in on this device (face or fingerprint unlock)',
    error: {
      isRequired: 'You must enter the one-time password',
      invalidCode: 'The one-time password was invalid',
      verificationFailed: 'Something went wrong. Please try again.',
      loginAgain:
        'You have entered an incorrect password too many times.\nTry to log in again [here](/).',
    },
  },
  link: {
    header: 'Linkki on nyt lähetetty!',
    description:
      'Saat muutaman minuutin kuluessa kirjautumislinkin sähköpostiosoitteeseen {email}.',
    resendCode:
      'Etkö saanut viestiä? Klikkaa [tästä](/email), niin lähetämme sinulle uuden viestin.',
  },
  login: { header: 'Logging in' },
  logout: { header: 'Logging out' },
  voucher: {
    header: 'Activation code',
    footer: 'Please enter the activation code you were given.',
    error: {
      isRequired: 'You must enter an activation code',
      invalidVoucher: 'The activation code was invalid',
      validationFailure:
        'Something happened that interrupted the activation. Please try again.',
    },
    activate: {
      title: 'Are you',
      cancel: 'No, change the code',
      accept: 'Yes',
    },
    product: {
      PROFESSIONAL: 'a school professional',
      STUDENT: 'a student',
    },
  },
  // /login-skolon (DEV-677). Functional strings, no voucher or
  // passwordless wording: a Skolon user never has a code to type.
  skolon: {
    signingIn: 'Signing you in…',
    // After logout. Terminal on purpose — the sign-in only starts
    // when the user asks for it. See SKOLON_LOGOUT_RETURN_PATH.
    loggedOut: {
      title: 'You’re signed out',
      body: 'Sign in with Skolon to get back to SomeBuddy.',
      action: 'Sign in with Skolon',
      // Resets PREFERRED_LOGIN_VARIANT and re-enters `/`, so
      // someone who is not a Skolon user is not stuck on this
      // screen on a shared browser.
      other: 'Sign in another way',
    },
    notConfigured: {
      title: 'Skolon sign-in isn’t available yet',
      body: 'Please contact support.',
    },
    noLicence: {
      title: 'Your school doesn’t have SomeBuddy through Skolon',
      body: 'Ask your school’s Skolon administrator for access.',
    },
    preparing: {
      title: 'We’re getting your school’s access ready',
      body: 'Please try again later. If this keeps happening, contact your school.',
    },
    noSeats: {
      title: 'Your school has no free seats left',
      body: 'Contact your school to get access.',
    },
    ended: {
      title: 'Your school’s access has ended',
      body: 'Contact your school to keep using SomeBuddy.',
    },
    error: {
      title: 'We couldn’t sign you in',
      body: 'Something went wrong while signing in with Skolon. Please try again.',
      retry: 'Try again',
    },
  },
  nav_menu: {
    deleteAccount: 'Delete my account',
    deleteConfirmTitle: 'Delete your account?',
    deleteConfirmDescription:
      "We'll send your request to our team, who will delete your account.",
    deleteConfirmAccept: 'Yes, delete',
    deleteConfirmCancel: 'Cancel',
    deleteRequested:
      "Thanks! We've got your request, and our team will delete your account.",
    deleteError: 'Something went wrong. Try again, or read more here.',
    changeLanguage: 'Change language',
    changeLanguageOther: 'Vaihda kieli / Byt språk',
    help: 'Do you have any questions?',
    // Shown in place of the support chat inside the native shell.
    // Static text plus a link out: no third-party script loads.
    helpPanel: {
      title: 'Having a problem with the app?',
      description: 'You can find answers and message us on our help pages.',
      link: 'Open the help centre',
      close: 'Close',
    },
    terms_of_service: 'Terms and conditions',
    privacy_policy: 'Privacy Policy',
    cookieSettings: 'Cookie settings',
    termsAndProtection: 'Terms & Privacy',
  },
  locale: {
    header: 'Choose language',
    subheader: 'Vaihda kieli / Välj språk',
    continue: 'Continue',
  },
  country: {
    header: 'Choose the country you live in',
    subheader: 'Valitse maa, jossa asut / Välj landet du bor i',
    continue: 'Continue',
  },
};

export default enGBTranslations;
